"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.createErrorSearchParamsString = void 0;
const createErrorSearchParamsString = ({ error, errorDescription, }) => {
    const errorParams = new URLSearchParams();
    if (error) {
        errorParams.set('error', error);
    }
    if (errorDescription) {
        errorParams.set('error_description', errorDescription);
    }
    return errorParams.toString();
};
exports.createErrorSearchParamsString = createErrorSearchParamsString;
